<template>

  <el-popover placement="bottom" width="160" v-model="showMarginType">
    <div style="margin-bottom:5px">
      <el-button @click="change(constants.CROSS)" style="width:100%">全仓</el-button>
    </div>
    <div>
      <el-button @click="change(constants.ISOLATED)" style="width:100%">逐仓</el-button>
    </div>
    <template #reference>
      <el-button icon="ArrowDownBold" style="width:120px" :loading="submitMarginTypeLoding">
        <span>{{ current.okxConfig.marginType === constants.CROSS ? '全仓' : '逐仓' }}</span>
      </el-button>
    </template>
  </el-popover>
</template>
<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import * as constants from '@/utils/okxConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const systemStore = useSystemStore()
const logStore = useLogStore()
const showMarginType = ref(false)
const submitMarginTypeLoding = ref(false)
const current = ref(systemStore.currentusymbol)

const change = (type) => {
  if (current.value.okxConfig.marginType === type) return
  save(type)
}

const save = async (type) => {
  try {
    //更新缓存
    let _obj = {
      name: current.value.name,
      marginType: type
    }
    systemStore.updateOkxMarginType(_obj)
  } catch (error) {
    ElMessage.error('获取杠杆失败' + error)
    logStore.addLog({
      title: '获取杠杆失败',
      level: 'error',
      message: error
    })
  }
}
</script>